import * as React from 'react';

import * as styles from './AvatarWrapper.css';

export const AvatarWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <span className={styles['container']}>{children}</span>;
};
